module.exports = __webpack_public_path__ + "static/img/idtype_offline_card.83652206.png";